/*
 * SPDX-FileCopyrightText: 2026 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { useApplicationState } from '../../hooks/common/use-application-state'
import { setNoteTreeSidebarOpen } from '../../redux/note-tree/methods'
import { cypressId } from '../../utils/cypress-attribute'
import { IconButton } from '../common/icon-button/icon-button'
import { useNoteTreeSidebarAvailable } from './use-note-tree-sidebar-available'
import React, { useCallback } from 'react'
import { LayoutSidebar as IconSidebar } from 'react-bootstrap-icons'
import { useTranslation } from 'react-i18next'

/**
 * Renders a button that expands or collapses the navigation sidebar.
 */
export const NoteTreeToggleButton: React.FC = () => {
  const { t } = useTranslation()
  const available = useNoteTreeSidebarAvailable()
  const open = useApplicationState((state) => state.noteTree.sidebarOpen)
  const onClick = useCallback(() => setNoteTreeSidebarOpen(!open), [open])

  if (!available) {
    return null
  }

  return (
    <IconButton
      icon={IconSidebar}
      variant={open ? 'secondary' : 'outline-secondary'}
      size={'sm'}
      onClick={onClick}
      title={t('noteTree.toggle')}
      aria-pressed={open}
      {...cypressId('note-tree-toggle')}
    />
  )
}
